import localStore from '@/utils/localStore';
import { ref, watch } from '@vue/composition-api';
import _uniqBy from 'lodash/uniqBy';

const MAX_SIZE = 12;

const loadData = () => localStore.getObject('mmsCardList') || [];

export default function useRecentCards() {
  const list = ref(loadData());

  /**
   * 추가
   * @param {{cardImageUrl: string; templateId: string}} item
   *
   * @todo 주문완료 시점에 최근 카드로 등록
   */
  const add = (item) => {
    list.value = _uniqBy([item, ...loadData()], 'templateId').slice(0, MAX_SIZE);
  };

  /**
   * 삭제
   * @param {string} templateId
   */
  const remove = (templateId) => {
    list.value = loadData().filter((item) => item.templateId !== templateId);
  };

  const clear = () => {
    list.value = [];
  };

  watch(list, (value) => localStore.setObject('mmsCardList', value || []));

  return {
    list,
    add,
    remove,
    clear,
  };
}
